module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.498 4a.5.5 0 01.5.5L13.997 8h9.042a2 2 0 011.561.75l2.4 3a2 2 0 010 2.5l-2.4 3a2 2 0 01-1.561.75h-9.042v9.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V19h2l-.001-1H6a2 2 0 01-2-2v-6a2 2 0 012-2h7.996V7h-1.998V4.5a.5.5 0 01.5-.5zm.498 6H6.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h7.496zm8.802 0h-8.801v6h8.801a.5.5 0 00.39-.188l2-2.5a.5.5 0 000-.624l-2-2.5a.5.5 0 00-.39-.188z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-address.svg
// module id = 676
// module chunks = 0